import styled from 'styled-components';

export const Container = styled.div`
  width: 440px;
  padding-top: 48px;
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    width: 160px;
    height: 66px;
  }

  div.return-btn {
    display: flex;
    width: 100vw;
    align-items: flex-start;
    padding-left: 20px;
    margin-top: -20px;
  }

  h3 {
    margin-top: 52px;
    color: var(--primary-color);
    font-size: 24px;
  }

  form {
    width: 100%;
    margin: 52px 0px;

    > div {
      margin-bottom: 24px;
    }

    button[type='submit'] {
      margin-top: 64px;
    }
  }

  @media (max-width: 768px) {
    img {
      width: 119px;
    }

    h3 {
      margin-top: 40px;
      font-size: 24px;
    }

    form {
      width: 70%;

      a {
        text-decoration: none;
        font-size: var(--font-small);
        font-weight: 400;
        color: var(--regular-gray);
      }
    }
  }

  @media (min-width: 1440px) {
    padding-top: 68px;

    h3 {
      margin-top: 75px;
    }

    form {
      margin-top: 56px;
    }
  }
`;

export const Subtitle = styled.h4`
  text-align: center;
  color: var(--medium-gray);
  padding: 15px;
  margin-bottom: -25px;

  @media (max-width: 768px) {
    width: 85%;
  }
`;
